import React, { ReactElement } from 'react';
import FormatService from '../../services/format-service';
import useStylesScrollableContainer from './scrollable-container.styles';

const ScrollableContainer: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isEmpty,
    className,
    maxHeight,
    children,
    ...custom
  } = props;

  const { classes } = useStylesScrollableContainer();

  const emptyClassName: string | undefined = isEmpty ? classes.scrollableContainerEmpty : undefined;

  return (
    <div
      className={FormatService.formatClassNames(classes.scrollableContainer, emptyClassName, className)}
      style={{
        maxHeight: maxHeight || undefined,
      }}
      {...custom}
    >
      {children}
    </div>
  );
});

export default ScrollableContainer;
